import { render } from "./routeberasa.vue?vue&type=template&id=724827e1"
import script from "./routeberasa.vue?vue&type=script&lang=js"
export * from "./routeberasa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__